import * as z from "zod";
import { dateSchema, REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
    z
        .object({ id: requiredString() })
        .or(z.literal(undefined))
        .refine((val) => !!val && !!val.id?.trim(), {
            message: REQUIRED_MESSAGE,
        });

export const basicDetailSchema = z.object({
    name: requiredString().nonempty("Casestudy cannot be empty"),
    project: requiredString(),
    status: requiredString(),
    project_name_alias: requiredString(),
    date_started: dateSchema,
    tag_line: requiredString(),
    team_size: z.number().int().min(0, "this field is required"),
    duration: requiredString(),
});
